import { Map } from 'immutable';

export default Map({
  error: null,
  data: null,
});
